import { render, staticRenderFns } from "./ApothekeMessages.vue?vue&type=template&id=4b13015e&"
import script from "./ApothekeMessages.vue?vue&type=script&lang=js&"
export * from "./ApothekeMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports